import { Box, FileSelector, Icon, LoaderNew, RadioButtonGroup, Spacer, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { isEmptyObject } from '@jfs/utils'
import { useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { useStores } from '../../data/store'
import { isAccessible, MessageTypes } from '../../utils'

const { REACT_APP_ENDPOINT = '' } = window?._env_

const BulkMerchantMapping = () => {
  const [filename, setFilename] = useState('')
  const [loading, setLoading] = useState(false)
  const [mids, setMids] = useState<any>([])
  const [inputKeys, setInputkeys] = useState<String[]>([])
  const [bulkAddMappingLoading, setBulkAddMappingLoading] = useState(false)
  const [bulkApprovalLoading, setBulkApprovalLoading] = useState(false)
  const [wsdata, setWsData] = useState<XlsxPopulate.Workbook>()
  const [isApproval, setIsApproval] = useState(false)

  const { sampleFileDownload, setMessage, bulkAddMapping, bulkApproval, accessConfig } = useStores((store) => ({
    bulkAddMapping: store.merchantMapping.bulkAddMapping,
    bulkApproval: store.merchantMapping.bulkApproval,
    setMessage: store.message.setMessage,
    sampleFileDownload: store.sampleFileDownload,
    accessConfig: store.user.getAccessConfig(['merchant_config', 'merchant_mapping']),
  }))

  const isValidEntry = (obj: any) => {
    if (isApproval) {
      return !isEmptyObject(obj)
    }
    return !isEmptyObject(obj) && !!obj?.merchantId
  }

  const columns = [
    'id',
    'merchantId',
    'entityId',
    'txnType',
    'instrumentType',
    'meCode',
    'mappingStatus',
    'reqType',
    'pgSecurityId',
    'secret',
    'chiper',
    'mcfg1',
    'mcfg2',
    'mappingStatus',
  ]
  const ApprovalColumns = ['id', 'key', 'username', 'approvalType', 'approvalStatus']
  const readExcel = async (file: any, name: string) => {
    if (!file) {
      setFilename(name)
      setWsData(undefined)
      return
    }
    setLoading(true)
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          setFilename(name)
          setWsData(workbook)
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          const uniqueValues: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                obj[key] = `${String(row._cells[i]?.value() ?? '')?.trim()}`
              }
            }
            isValidEntry(obj) && values.push(obj)
          })
          let filterdObj: any = {}
          rows?.forEach((element) => {
            const key: any = element?.cell(2)?.value()
            if (!!key && !filterdObj[key]) {
              filterdObj[key] = element
            }
          })
          const filteredRows = Object.values(filterdObj)
          filteredRows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row?._cells?.length; i++) {
              if (rowIndex !== 0) {
                const key = keys[i - 1]
                obj[key] = `${row?._cells[i]?.value() ?? ''}`
              }
            }
            !isEmptyObject(obj) && uniqueValues.push(obj)
          })
          const isExcelInvalid = isApproval
            ? ApprovalColumns.some((item) => !keys.includes(item))
            : columns.some((item) => !keys.includes(item))
          if (!isExcelInvalid) {
            setMids(values)
            setInputkeys(keys)
            resolve(values)
          } else {
            reject('Invalid File')
          }
        })
        .catch(() => {
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setWsData(undefined)
      setFilename('')
      setMessage(e, MessageTypes.ERROR)
    }
    setLoading(false)
  }

  const onBulkUpload = async (apiCall: any, loaderFunc: (b: boolean) => void, fileName: string) => {
    loaderFunc(true)
    const errorData: any[] = await apiCall(mids)
    loaderFunc(false)

    let transformedData: any = []
    const modifiedMidData = JSON.parse(JSON.stringify(mids))
    modifiedMidData?.forEach((item) => {
      inputKeys?.forEach((key) => {
        if (item[key as keyof typeof item] === undefined) {
          item[key as keyof typeof item] = ''
        }
      })
    })
    transformedData = errorData.map((item) => [item.status, item.message, item.code])
    transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const data: any = []
      data.push([...inputKeys, ...transformedData[0]])
      modifiedMidData.map((item: any, index: number) => {
        data.push([...Object.values(item), ...transformedData[index + 1]])
      })

      workbook.sheet(0)?.cell('A1').value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })
      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = `merchantResult_${fileName}.xlsx`
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }
  const onChange = (val: string) => {
    setIsApproval(val === 'Approval')
    setWsData(undefined)
    setFilename('')
  }

  const handlePress = () => {
    if (isApproval) {
      onBulkUpload(bulkApproval, setBulkApprovalLoading, filename)
    } else {
      onBulkUpload(bulkAddMapping, setBulkAddMappingLoading, filename)
    }
  }

  const getRadioButtonData = () => {
    const retData = []
    if (isAccessible(accessConfig, 'add')) {
      retData.push('Add/ Update')
    }
    if (isAccessible(accessConfig, 'approve')) {
      retData.push('Approval')
    }
    return retData
  }
  return (
    <Box flex={1} bg="WHITE" align="center" overflow={'auto'}>
      <RadioButtonGroup
        data={getRadioButtonData()}
        value={getRadioButtonData()?.[0]}
        direction={'horizontal'}
        onChange={onChange}
      />
      <FileSelector
        innerCompTitle={`Please upload Merchant mapping ${isApproval ? 'Approval' : ''} file`}
        onFileSelect={readExcel}
        fileType=".xlsx"
        filename={filename}
      />
      <Spacer size={16} />
      <ButtonNew
        disabled={!wsdata}
        paddingVertical={16}
        title={isApproval ? 'Bulk Approve' : 'Add/ Update'}
        isLoading={isApproval ? bulkApprovalLoading : bulkAddMappingLoading}
        type="primary"
        onPress={handlePress}
      />
      <Spacer size={32} />
      <a
        href={
          isApproval
            ? `${REACT_APP_ENDPOINT}/sample_bulk_mapping_approval_file.xlsx`
            : `${REACT_APP_ENDPOINT}/sample_add_merchant_mapping.xlsx`
        }
        style={{ textDecoration: 'none' }}
        rel="noopener noreferrer"
        target="_blank">
        <Box flexDirection={'row'} align={'center'}>
          <Icon id={'DOWNLOAD'} color={'PRIMARY'} />
          <Spacer size={8} direction={'horizontal'} />
          <TextNew fontFamily={'jiotype-medium'} fontSize={14} color={'PRIMARY'}>
            {isApproval ? 'Sample Approval File' : 'Sample Mapping File'}
          </TextNew>
        </Box>
      </a>
      {loading && (
        <Box
          backgroundColor={'TRANSPARENT'}
          position={'absolute'}
          left={0}
          right={0}
          top={0}
          bottom={0}
          alignItems="center"
          justify="center">
          <LoaderNew color={'PRIMARY'} type="large" />
        </Box>
      )}
    </Box>
  )
}

export default BulkMerchantMapping
